const map = {
	"./command-palette-element.js": 86043,
	"./command-palette/command-palette-group-element.js": 6685,
	"./command-palette/command-palette-header-element.js": 85087,
	"./command-palette/command-palette-item-element.js": 63817,
	"./command-palette/command-palette-stack-element.js": 31338,
	"custom-elements/command-palette-element.js": 86043,
	"custom-elements/command-palette/command-palette-group-element.js": 6685,
	"custom-elements/command-palette/command-palette-header-element.js": 85087,
	"custom-elements/command-palette/command-palette-item-element.js": 63817,
	"custom-elements/command-palette/command-palette-stack-element.js": 31338
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16263;